export const API = {
  PARTNER_STORE: '/partner-store',
  BUSINESS_INFORMTAION: '/business-information',
  STORE_FEATURE: '/store-feature',
  OPTION_PRODUCT: '/option-product',
  TOURIST_SPOT: '/tourist-spot',
  STORE_TERMS: '/store-terms',
  ROOM_TYPE: '/room-type',
  ROOM: '/room',
  SEASON: '/season',
  ROOM_RATE: '/room-rate',
  CODE: '/code',
  ADMIN: '/admin',
  MAIN_BANNER: '/main-banner',
  NOTICE: '/notice',
  OUR_NEWS: 'our_news',
  USER_WEB: '/user-web',
  LOGIN: '/authentication/login',
  RESERVATION: '/reservation',
  NICE_PAY: '/nice-pay',
  NICE_ID: '/nice-id',
  ACCOUNT_CONFIRMATION: '/account-confirmation',
  AUTHENTICATION: '/authentication/refresh-token',
  AUTHENTICATION_LOGOUT: '/authentication/logout',
  ACCESS_TOKEN: '/authentication/access-token',
  TERMS: '/terms',
  CONSULTING: '/consulting',
  HEALTH_CHECK: '/healthCheck',
  PARTNER_NOTICE: '/partner-notice',
  EVENT_STAY: 'event-stay',
  MAIN_STAY: 'main-stay',
  RESERVATION_AVAILABLE_DATE: 'reservation-available-date',
  ROOM_PRICE: 'room-price',
};
